import BaseService from "../index";

export default {
    get() {
        return BaseService.get(`/cms/thank-you-page`);
    },

    update(params) {
        return BaseService.put(`/cms/thank-you-page`, params);
    },
};
